import { engineComponent } from "neo-common";
import { FrameTimerEventEmitter, CreateFrameTimer, FrameTimerEvents } from "../../Utils/FrameTimer";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";

@engineComponent(ComponentTypes.DisplayObject)
export class Spot extends SwitchElement {
    delayedTimer: FrameTimerEventEmitter;
    delayedCase: string;
    enabled: boolean;

    constructor() {
        super();

        this.delayedTimer = CreateFrameTimer("delayedTimer");
        this.enabled = false;
    }

    delayedGoToCase(delay: number, delayedCase: string): void {
        this.delayedCase = delayedCase;

        this.delayedTimer.stop();
        this.delayedTimer.removeAllListeners(FrameTimerEvents.Complete);
        this.delayedTimer.on(FrameTimerEvents.Complete, this.delayedToCase.bind(this));
        this.delayedTimer.start(delay);
    }

    private delayedToCase(): void {
        if (this.delayedCase != null || this.delayedCase != "") {
            this.delayedTimer.stop();
            this.delayedTimer.removeAllListeners(FrameTimerEvents.Complete);
            this.goToCase(this.delayedCase);
            this.delayedCase = "";
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Pick/Spot.ts
 **/